<template>
  <div class="work-done">
    <div
      ref="public-searchForm"
      class="public-searchForm work-search"
    >
      <el-form
        ref="searchForm"
        :model="searchForm"
        labelWidth="100px"
        @keyup.enter.native="search"
      >
        <el-form-item
          prop="businessKey"
          label="表单号"
        >
          <WSelectBusinessKey v-model.trim="searchForm.businessKey" />
        </el-form-item>
        <el-form-item
          prop="modelName"
          label="流程模型"
        >
          <WSelectInput
            v-model="searchForm.modelName"
            component="selectFlow"
            placeholder="请选择流程模型"
            title="请选择流程模型"
            inDialog
            closeHandle
            width="900px"
            @handleSelect="handleFlowModel"
          />
        </el-form-item>
        <el-form-item
          label=""
          labelWidth="0"
        >
          <div style="display: flex; justify-content: flex-end; align-items: center;">
            <el-link
              :underline="false"
              type="primary"
              style="width: 56px; margin-right: 10px;"
              @click="toggleOpen"
            >
              {{ openAll ? '收起更多' : '更多条件' }}
            </el-link>
            <el-button
              icon="el-icon-refresh"
              @click="reset"
            >
              重置
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-search"
              :loading="loading.search"
              @click="search"
            >
              查询
            </el-button>
          </div>
        </el-form-item>
        <el-form-item
          prop="taskDefName"
          label="处理节点"
        >
          <el-input
            v-model.trim="searchForm.taskDefName"
            clearable
            placeholder="请输入处理节点"
          />
        </el-form-item>

        <el-form-item
          prop="startUserIdView"
          label="发起人"
        >
          <WSelectInput
            v-model="searchForm.startUserIdView"
            component="selectMultipleUser"
            placeholder="请选择发起人"
            title="请选择发起人"
            inDialog
            closeHandle
            multiple
            width="900px"
            @submit="handleStartUser"
          />
        </el-form-item>

        <el-form-item
          v-show="false"
          prop="category"
        />
        <el-form-item
          prop="categoryName"
          label="模型分类"
        >
          <WSelectInput
            v-model="searchForm.categoryName"
            component="selectCategory"
            placeholder="请选择模型分类"
            title="请选择模型分类"
            inDialog
            width="500px"
            @handleSelect="handleCategory"
          />
        </el-form-item>
        <WQueryCriteria
          :show="openAll"
          :value="searchForm"
          :modelKey="searchForm.modelKey"
          @resetTableHeight="resetTableHeight"
        >
          <el-form-item
            prop="startTime"
            label="处理时间"
            style="width: 66.66%;"
          >
            <el-date-picker
              v-model="searchForm.startTime"
              clearable
              type="datetimerange"
              placeholder="请选择处理时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item
            prop="processName"
            label="流程标题"
          >
            <el-input
              v-model.trim="searchForm.processName"
              clearable
              placeholder="请输入流程标题"
            />
          </el-form-item>
          <el-form-item
            prop="processStatus"
            label="流程状态"
          >
            <el-select
              v-model="searchForm.processStatus"
              placeholder="请选择流程状态"
              clearable
            >
              <el-option
                v-for="option in processStatusList"
                :key="option.key"
                :value="option.key"
                :label="option.label"
              />
            </el-select>
          </el-form-item>
        </WQueryCriteria>
      </el-form>
    </div>
    <div class="public-table">
      <div class="public-table-top">
        <div class="table-title">
          已办任务列表
        </div>
        <div class="public-table-top-btn">
          <el-button
            v-if="menuBottonRole.includes('export')"
            type="primary"
            size="mini"
            :disabled="!selectionList.length"
            @click="exportBatch"
          >
            批量导出
          </el-button>
        </div>
      </div>
      <el-table
        v-if="showTable"
        ref="tableData"
        :height="tableHeight"
        :data="tableData"
        border
        @selection-change="selectionChange"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
        />
        <el-table-column
          type="selection"
          align="center"
        />
        <el-table-column
          label="表单号"
          :minWidth="200"
        >
          <div
            slot-scope="scope"
            class="public-form-table-item-operate"
          >
            <a @click="open(scope.row)">{{ scope.row.businessKey }}</a>
          </div>
        </el-table-column>
        <el-table-column
          v-for="item in tableCol"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :min-width="item.minWidth"
        />
        <el-table-column
          label="操作"
          width="100"
          fixed="right"
        >
          <div
            slot-scope="scope"
            class="public-form-table-item-operate"
          >
            <WHandleButton
              :key="scope.row.taskId + '_handle'"
              :scope="scope"
              :controlData="controlData"
              type="done"
              @handle="handleClick($event, scope.row)"
            />
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      ref="public-pagination"
      class="public-pagination"
    >
      <WPagination
        v-model="page"
        @change="query"
      />
    </div>
    <ValidExport
      v-model="showValid"
      :data="selectionList"
    />
  </div>
</template>
<script>
import api from '@workflow/api/index.js'
import handleButton from '@workflow/mixins/handleButton.js'
import tableHeight from '@workflow/mixins/tableHeight.js'
import queryCriteria from '@workflow/mixins/queryCriteria.js'
import ValidExport from '@workflow/components/validExport/validExport.vue'
export default {
  name: 'WorkDoneList',
  components: {
    ValidExport
  },
  mixins: [tableHeight, handleButton, queryCriteria],
  data() {
    const assignee = this.$store.state.workflow.userInfo.employeeNo
    return {
      assignee,
      loading: {
        search: false,
        export: false
      },
      openUrl: '/form/done',
      searchForm: {
        assignee,
        businessKey: '',
        processName: '',
        category: '',
        categoryName: '',
        startUserIds: [],
        startUserIdView: '',
        modelKey: '',
        modelName: '',
        startTime: [],
        processStatus: '',
        taskDefName: '',
        queryCriteria: {}
      },
      selectParam: {},
      page: {},
      controlNum: 0,
      controlData: {},
      showValid: false,
      selectionList: [],
      processStatusList: [
        { key: 'UNFINISHED', label: '运行中' },
        { key: 'FINISHED', label: '已结束' }
      ],
      tableData: [],
      tableCol: [
        { label: '流程标题', key: 'processName', minWidth: 200 },
        { label: '流程模型', key: 'processModelName', minWidth: 200 },
        { label: '发起人', key: 'startUserIdView', minWidth: 150 },
        { label: '处理时间', key: 'taskEndTime', minWidth: 150 },
        { label: '处理节点', key: 'taskDefName', minWidth: 150 },
        { label: '流程状态', key: 'status', minWidth: 100 }
      ]
    }
  },
  computed: {
    menuBottonRole() {
      const map = this.$store.state.workflow.menuBottonRole['/work/doneList'] || []
      return map.map(item => item.menuUrl)
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    reset() {
      this.$refs.searchForm.resetFields()
      this.searchForm.category = ''
      this.searchForm.modelKey = ''
      this.searchForm.startUserIds = []
      this.searchForm.queryCriteria = {}
      this.search()
    },
    handleCategory({ id = '', name = '' } = {}) {
      this.searchForm.category = id
      this.searchForm.categoryName = name
    },
    handleFlowModel({ modelKey = '', name = '' } = {}) {
      this.searchForm.modelKey = modelKey
      this.searchForm.modelName = name
    },
    handleStartUser(data) {
      this.searchForm.startUserIds = data ? data.map(item => item.jobId) : []
      this.searchForm.startUserIdView = data ? data.map(item => item.name).join(',') : ''
    },
    selectionChange(selection) {
      this.selectionList = selection
    },
    exportBatch() {
      if (this.loading.export) return
      const [keys, formIds, nodeIds] = [new Set(), new Set(), new Set()]
      this.selectionList.forEach(item => {
        keys.add(item.modelKey) // 流程模型
        formIds.add(item.formDefinitionId) // 表单版本
        nodeIds.add(item.taskDefKey) // nodeId
      })
      if (keys.size > 1 || formIds.size > 1 || nodeIds.size > 1) {
        this.showValid = true
        return
      }
      this.loading.export = true
      const { modelKey, formDefinitionId, taskDefKey } = this.selectionList[0]
      this.$api.personalOffice.export({
        modelKey,
        formDefinitionId,
        taskDefKey,
        businessKeys: this.selectionList.map(item => item.businessKey)
      })
      setTimeout(() => {
        this.loading.export = false
      }, 1500)
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }

      const startTime = this.selectParam.startTime
      delete this.selectParam.startTime
      if (startTime && startTime.length) {
        this.selectParam.startTime = startTime[0]
        this.selectParam.endTime = startTime[1]
      }
      delete this.selectParam.modelName
      delete this.selectParam.startUserIdView
      delete this.selectParam.categoryName
      this.selectParam.queryCriteria = this.getQueryCriteria()
      this.query()
    },
    query() {
      this.loading.search = true
      const { current, size } = this.page
      api.personalOffice.getDoneList({
        pageParam: { current, size },
        selectParam: this.selectParam,
        sorts: [{ asc: false, column: 'taskEndTime' }]
      }).then(data => {
        data.records.forEach(item => {
          item.status = item.endTime ? '已结束' : '运行中'
        })
        this.controlData = {}
        this.tableData = data.records
        this.page.total = data.total
        if (!data.records.length) return this.$message.warning('查无数据！')
        this.initBtnControl(++this.controlNum)
      }).finally(() => {
        this.loading.search = false
      })
    },
    initBtnControl(num) {
      api.formModel.getBtnControl(this.tableData.map(item => {
        return {
          modelKey: item.modelKey || item.processDefinitionKey,
          nodeId: item.taskDefKey
        }
      })).then(data => {
        if (num === this.controlNum) {
          this.controlData = data
        }
      })
    },
    trace(row) {
      window.open(`/#/form/trace?id=${row.processInstanceId}`)
    }
  }
}
</script>
